<template>
    <div class="csstmManage">
         <div class="main-flex">
            <edit-btns class="btn-box" 
                :bnts="['query','add']"
                @addClick="add()"
                @queryClick="loadData()"/>
        </div>
        <div class="filter-box">
            <div class="from-box">
                <div class="lable-txt">检索:</div>
                <key-board-input class="from-input search"
                    type="text" v-model="searchTxt" placeholder="编号、名称、手机号糊检索"
                    isKeyEnterClose isBlurClose
                    :keyOptions="{isKeyDownEnter:true}"
                ></key-board-input>
            </div>
        </div>
        <div class="data-box">
            
            <div class="table-box" ref="tableBox">
                <el-table style="width: 100%;height:100%"  v-mouse-scroll="{scrollName:'.el-table__body-wrapper'}" border
                     :data="pageTableData"
                     highlight-current-row
                     @row-dblclick="dblclick"
                >
                    <el-table-column fixed label="序号" width="40" >
                        <template #default="scope">{{scope.$index+1+(pageIndex*pageSize)}}</template>
                    </el-table-column>
                    <el-table-column prop="ClientCode"  label="编码" min-width="100" align="left"> </el-table-column>
                    <el-table-column prop="ClientName"  label="客户名称" min-width="100" align="left"></el-table-column>
                    <el-table-column prop="Cstm_LevelName" label="会员等级" min-width="100"></el-table-column>
                    <el-table-column prop="Gender" label="性别" min-width="50">
                        <template #default="scope">
                            {{scope.row.Gender==1?"女":"男"}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="BelongDepartment" label="所属门店" min-width="100" align="left"></el-table-column>
                    <el-table-column prop="Mobile" label="手机号" min-width="100" align="left"></el-table-column>
                    <el-table-column label="会员卡张数" min-width="80">
                        <template #default="scope">
                            <template v-if="scope.row.Card_NoList &&  scope.row.Card_NoList.length>0">
                                <el-tooltip  effect="dark" :content="scope.row.Card_NoList.toString()" placement="top">
                                    <div class="link">{{ scope.row.Card_NoList.length }}</div>
                                </el-tooltip>
                            </template>
                            <template v-else>0</template>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Habits" label="喜好" min-width="100" align="left"></el-table-column>
                    <el-table-column prop="Taboos" label="忌讳" min-width="100" align="left"></el-table-column>

                    <el-table-column prop="Remark" label="备注" min-width="120" align="left"></el-table-column>
                    <el-table-column prop="Create_ID" label="创立人" width="100" align="left"></el-table-column>
                    <el-table-column prop="Create_Time" label="创立时间" width="130" align="left" :formatter="dateFormat"></el-table-column>
                    <el-table-column prop="Update_ID" label="最后更新人" width="100" align="left"></el-table-column>
                    <el-table-column prop="Update_Time" label="最后更新时间" width="130" align="left" :formatter="dateFormat"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="80">
                        <template #default="scope" >
                            <el-button @click="dblclick(scope.row)" type="text" size="small">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="page-box">
                <span>当前第 {{pageIndex+1}} 页 &nbsp;&nbsp;&nbsp;&nbsp; 共{{tablePageSum}}页</span>
                <div class="page-button">
                     <span class="but but-up" @click="billPage()">上一页</span>
                     <span class="but but-down"  @click="billPage(1)">下一页</span>
                </div>
            </div>
        </div>
        <!-- 券列表 -->
        <modal-load :isShow="editShow">
            <edit-csstm-manage-model :isShow="editShow" 
                :clientLevelList="clientLevelList"
                :data="editManageInfo"
                @close="editShow=false"
                @confirm="confirm"/>
        </modal-load> 
    </div>
</template>

<script>
import editCsstmManageModel from './editCsstmManageModel/editCsstmManageModel.vue'
export default {
    components:{
        editCsstmManageModel
    },
    data(){
        return {
            searchTxt:"",
            pageIndex:0,
            pageSize:100,
            tableData:[],
            //编辑新增 弹层
            editShow:false,
            //编辑会员的 数据
            editManageInfo:null,
            //客户级别数据
            clientLevelList:null
        }
    },
    computed:{
        dataFilter(){
            let list=this.tableData||[];
            let text=this.searchTxt.trim().toUpperCase();
            if(text){
                list=list.filter(it=> (it.ClientCode||"").toUpperCase().indexOf(text)>=0 
                    || (it.ClientName||"").toUpperCase().indexOf(text)>=0
                    || (it.Mobile||"").toUpperCase().indexOf(text)>=0);
            }
            return list;
        },
        pageTableData(){
            return this.dataFilter.slice(this.pageIndex*this.pageSize,(this.pageIndex+1)*this.pageSize);
        },
        tablePageSum(){
            let length=this.dataFilter.length;
            if(length>1){
                return Math.ceil(length/this.pageSize);
            }
            return 1;
        }
    },
    watch:{
        searchTxt(){
            this.pageIndex=0;
        }
    },
    mounted(){
        this.loadData();
    },
    methods:{
        back(){
            this.$router.push("setup");
        },
        /*时间格式 */
        dateFormat(row, column, cellValue) {
            if(!cellValue || cellValue=='0001-01-01T00:00:00'){
                return '';
            }
            return (new Date(cellValue)).Format('yyyy-MM-dd hh:mm:ss');
        },
        /**计算 一页显示多少条数据 */
        setTablePageSize(){
            if(this.$refs.tableBox){
                this.$nextTick(()=>{
                    let height=this.$refs.tableBox.clientHeight - 40;
                    this.pageSize=parseInt(height/50);
                })
            }
        },
        async GetClientLevelList(isLoad){
            if(this.clientLevelList){
                return;
            }

            let loading=null;
            if(isLoad){
                loading = this.$loading({
                    text: "数据加载中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
            }
            
            await this.$httpAES.post("Bestech.CloudPos.Member.GetClientLevelList",{}).then((d)=>{
                console.log(d)
                if(isLoad){
                    loading.close();
                }
                if(d.ResponseHeader.ResultCode==0){
                    this.clientLevelList=d.ResponseBody||[];
                }else{
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                if(isLoad){
                    loading.close();
                }
                this.$message.error('加载客户级别数据失败：'+e);
                console.log('加载客户级别据失败：'+e);
            })
        },
        loadData(){
            const loading = this.$loading({
                text: "数据加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.tableData=[];
            this.pageIndex=0;
            this.$httpAES.post("Bestech.CloudPos.GetCrmClients",{}).then((d)=>{
                loading.close();
                if(d.ResponseHeader.ResultCode==0){
                    this.tableData=d.ResponseBody||[];
                    this.setTablePageSize();
                }else{
                    this.tableData=[];
                    this.$message.error(d.ResponseHeader.ResultDesc);
                }
            }).catch((e)=>{
                this.tableData=[];
                loading.close();
                this.$message.error('加载客户资料数据失败：'+e);
                console.log('加载客户资料数据失败：'+e);
            })
        },
        /**双击 某一行*/
        dblclick(row){
            this.editManageInfo=row;
            this.editShow=true;
            this.GetClientLevelList(true);
        },
        /**新增 */
        add(){
            this.editManageInfo=null;
            this.editShow=true;
            this.GetClientLevelList(true);
        },
        /**账单数据分页 */
        billPage(type){
            if(type==1){
                if(this.pageIndex+1<this.tablePageSum){
                    this.pageIndex++;
                }else{//下一页
                    this.$message.warning('已到最后一页');
                }
            }else{//上一页
                if(this.pageIndex==0){
                    this.$message.warning('已到第一页');
                }
                this.pageIndex>0?this.pageIndex--:this.pageIndex=0;
            }
        },
        //编辑保存成功返回
        confirm(d){
            console.log(d);
            this.editShow=false;
            this.loadData();
        }
    }
}
</script>

<style lang="scss">
@import './csstmManage.scss'
</style>